/**
 * The "Dropstack" logo: chunky bouncing letters plus a little well where a sum
 * block drops onto a brick stack. Pure CSS/SVG (styles in wordmark.css); all
 * motion stops under reduced motion. Brand colours are fixed across themes;
 * the dark outline keeps the letters readable on every sky.
 */
import type { CSSProperties } from 'react';
import './wordmark.css';

const WORD = 'Dropstack';

export interface WordmarkProps {
  /** compact: smaller, no motif (the Watch). */
  size?: 'full' | 'compact';
}

export function Wordmark({ size = 'full' }: WordmarkProps) {
  return (
    <span className={`ui-wordmark ui-wordmark--${size}`}>
      {size === 'full' && <WellMotif />}
      <span className="ui-wordmark__word" aria-hidden="true">
        {[...WORD].map((letter, i) => (
          <span key={i} className="ui-wordmark__letter" style={{ '--i': i } as CSSProperties}>
            {letter}
          </span>
        ))}
      </span>
      <span className="visually-hidden">{WORD}</span>
    </span>
  );
}

/** A tiny well: a "2+3" block falls and lands on two brick layers. */
function WellMotif() {
  return (
    <svg className="ui-wordmark__motif" viewBox="0 0 64 80" aria-hidden="true" focusable="false">
      <g className="wm-block">
        <path className="wm-trail" d="M24 -6v8M32 -10v8M40 -6v8" />
        <rect className="wm-block__body" x="15" y="6" width="34" height="24" rx="6" />
        <text className="wm-block__text" x="32" y="23.5" textAnchor="middle">
          2+3
        </text>
      </g>
      <g className="wm-bricks">
        <rect x="10" y="60" width="21" height="12" rx="3" />
        <rect x="33" y="60" width="21" height="12" rx="3" />
        <rect className="wm-brick--b" x="10" y="46" width="12" height="12" rx="3" />
        <rect className="wm-brick--b" x="24" y="46" width="17" height="12" rx="3" />
        <rect className="wm-brick--b" x="43" y="46" width="11" height="12" rx="3" />
      </g>
      <path className="wm-well" d="M6 12v58a7 7 0 0 0 7 7h38a7 7 0 0 0 7-7V12" />
    </svg>
  );
}
